<template>
  <div>
    <!-- <div class="choose-box--feature">
      <div class="choose-box--feature__small">FEATURES FOR</div>
      <div class="choose-box--feature__large">Partners or Sponsors</div>
      <div class="choose-box--feature__medium">
        MyCircles enables organizations to reach high quality audiences to
        achieve desired visibility by defined targeted markets. Bringing
        together our network of healthcare professionals with the convenience
        Dove Campaigns enables our partners to ensure that their marketing
        efforts are directed and reaching those who are in need of their
        products and services.
      </div>
    </div> -->
    <div class="create-support  reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/partner1.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">PROMOTE</div>
        <div class="create-support__description__large">
          Products and services and current deals
        </div>
        <div class="create-support__description__medium">
          Make your ad campaigns count by reaching quality health-minded
          individuals in your local community. Customize your Campaign by adding
          a specified set of filters to target the optimal audience for your
          Campaign.
        </div>
        <!-- <div class="create-support__description__button">
          CALL TO ACTION
        </div> -->
      </div>
    </div>
    <div class="full dark-bg">
      <div class="create-support dovemed-wrapper  ">
        <div class="create-support__image">
          <img
            alt="img"
            src="../../../../assets/images/partner2.jpg"
            class="img-src"
          />
        </div>
        <div class="create-support__description">
          <div class="create-support__description__small">
            Track and Customize
          </div>
          <div class="create-support__description__large">
            Campaign
          </div>
          <div class="create-support__description__medium">
            Use our analytical tools and reports provided in your dashboard to
            track the current progress of your campaign. Additionally, opt-in to
            automatically receive daily, weekly, and monthly reports that
            capture your campaigns’ performance delivered straight to your
            inbox.
          </div>
          <!-- <div class="create-support__description__button">
            CALL TO ACTION
          </div> -->
        </div>
      </div>
    </div>
    <div class="create-support  reverse">
      <div class="create-support__image">
        <img
          alt="img"
          src="../../../../assets/images/partner3.jpg"
          class="img-src"
        />
      </div>
      <div class="create-support__description">
        <div class="create-support__description__small">
          INCREASE
        </div>
        <div class="create-support__description__large">
          Brand Awareness
        </div>
        <div class="create-support__description__medium">
          Optimize visibility among members of your community. Build your
          brand’s image and increase brand awareness from reputable physicians
          and other healthcare professionals. Educate your community on new
          technologies and innovations aimed at healthier lifestyles.
        </div>
        <!-- <div class="create-support__description__button">
          CALL TO ACTION
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartnerStatic"
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/App/circle/AllCircleStaticPages/PartnerStatic.vue